import { useGuidance } from "../contexts/GuidanceContext";
import { cn } from "../lib/cn";

export function GuidanceToggle() {
  const { isGuidanceActive, toggleGuidance } = useGuidance();
  return (
    <button
      type="button"
      role="switch"
      aria-checked={isGuidanceActive}
      onClick={toggleGuidance}
      className={cn(
        "inline-flex items-center gap-2 rounded-md border px-2.5 py-1.5 text-xs font-medium transition",
        isGuidanceActive
          ? "border-brand-600 bg-brand-50 text-brand-700 dark:border-brand-500 dark:bg-brand-500/10 dark:text-brand-100"
          : "border-slate-200 bg-white text-slate-600 hover:text-slate-900 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300 dark:hover:text-white",
      )}
      title={
        isGuidanceActive
          ? "Coach guidance is on. Click to hide consultant tips."
          : "Coach guidance is off. Click to show consultant tips."
      }
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="h-4 w-4"
        aria-hidden="true"
      >
        <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
        <path d="M6 12v5a6 6 0 0 0 12 0v-5" />
      </svg>
      <span>Coach</span>
      <span
        aria-hidden="true"
        className={cn(
          "ml-1 inline-flex h-4 w-7 items-center rounded-full p-0.5 transition",
          isGuidanceActive ? "bg-brand-600" : "bg-slate-300 dark:bg-slate-600",
        )}
      >
        <span
          className={cn(
            "h-3 w-3 rounded-full bg-white transition",
            isGuidanceActive ? "translate-x-3" : "translate-x-0",
          )}
        />
      </span>
    </button>
  );
}
